export default __webpack_public_path__ + "static/media/printer.41beea9d.svg";